import { toast } from '@zerodevx/svelte-toast';

export const successToast = m => toast.push(m, {
  theme: {
    '--toastBackground': '#96e8b8',
    '--toastColor': '104210',
    '--toastBarBackground': '#27B060'
  }
})

export const warningToast = m => toast.push(m, { theme: {
    '--toastBackground': '#fff4b3',
    '--toastColor': 'black',
    '--toastBarBackground': '#f5af25'
  }
})

export const failureToast = m => toast.push(m, { theme: {
  '--toastBackground': '#ffcccc',
  '--toastColor': '#7e1e15',
  '--toastBarBackground': 'maroon'
}})